import React from 'react';

import ProductionLineCard from './ProductionLineCard';

const ProductionLane = ({
  title,
  items,
  actionLabel = '',
  onAction = null,
  busyItemId = null,
  emptyMessage = 'Bu alanda gosterilecek urun yok.',
}) => (
  <section className="venue-production-lane">
    <header className="venue-production-lane__header">
      <h2 className="venue-production-lane__title">{title}</h2>
      <span className="venue-production-lane__count">{items.length}</span>
    </header>

    <div className="venue-production-lane__items">
      {items.length === 0 ? (
        <div className="venue-production-lane__empty">{emptyMessage}</div>
      ) : (
        items.map((item) => (
          <ProductionLineCard
            key={item.orderItemId}
            item={item}
            actionLabel={actionLabel}
            busy={busyItemId === item.orderItemId}
            onAction={onAction}
          />
        ))
      )}
    </div>
  </section>
);

export default ProductionLane;
